import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { ServiceSpeedPipe } from "../../../../../helpers/service-speed-pipe/service-speed-pipe";
import { ServiceType } from "../../../../../pages/subscription-detail/types";
import { ServiceIcon } from "../../../service-icon/service-icon";

@Component({
  selector: "service-row",
  templateUrl: "service-row.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, ServiceIcon, ServiceSpeedPipe],
})
export class ServiceRowComponent {
  protected service = input.required<ServiceType>();
  protected active = input.required<boolean>();

  private product = computed(() => this.service().product);
  private productTag = computed(() => this.product().tag);
  protected productType = computed(() => this.product().type);

  protected isFirewall = computed(() => this.productType() === "FW");
  protected isMsc = computed(() => this.productTag() === "MSC");

  // Firewalls are shown as the IP service they protect, with a firewall badge on top.
  protected iconType = computed(() => (this.isFirewall() ? "ip" : this.productType().toLowerCase()));

  protected serviceSpeed = computed(() => this.service().speed);
  protected title = computed(() => this.service().customerDescription ?? this.service().description);
}
